import React from 'react'
import { Button, Modal, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { Dimension, UndoRequestResponse } from '../../../../../features/dimension/types/Dimension'
import { sampleNamesText } from '../utils/dimensionDeletePlan'

const { Text } = Typography

interface DimensionUndoConfirmProps {
  open: boolean
  undoEntry: UndoRequestResponse<Dimension> | undefined
  isUndoing: boolean
  onConfirm: () => void
  onClose: () => void
}

const headingKeyByMethod: Record<string, string> = {
  DELETE: 'dimensionsPage:undoConfirmHeadingDelete',
  POST: 'dimensionsPage:undoConfirmHeadingCreate',
  PUT: 'dimensionsPage:undoConfirmHeadingUpdate'
}

const DimensionUndoConfirm: React.FC<DimensionUndoConfirmProps> = ({
  open,
  undoEntry,
  isUndoing,
  onConfirm,
  onClose
}) => {
  const { t } = useTranslation()

  if (!undoEntry) return null

  const names = (undoEntry.events ?? []).map(e => e.data.name)
  const headingKey = headingKeyByMethod[undoEntry.method]
  const heading = headingKey ? t(headingKey, { count: names.length }) : t('dimensionsPage:undoConfirmHeadingGeneric')

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={480}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t('global:no')}
        </Button>,
        <Button key="ok" type="primary" loading={isUndoing} onClick={onConfirm} style={{ marginLeft: 8 }}>
          {t('global:yes')}
        </Button>
      ]}
    >
      <Typography.Title level={5} style={{ margin: '0 0 8px' }}>
        {heading}
      </Typography.Title>
      {names.length > 0 && (
        <Text type="secondary" style={{ fontSize: 13 }}>
          {t('dimensionsPage:undoConfirmNamesLabel', { names: sampleNamesText(names, t) })}
        </Text>
      )}
    </Modal>
  )
}

export default DimensionUndoConfirm
